export default __webpack_public_path__ + "static/media/starbucks.a31fdd11.png";